// @flow strict
import * as React from 'react';

/**
 * @ignore
 */
export const ArrowIndent = (): React.Element<*> => (
  <path d="M15.996 11.992c0-0 0-0 0-0 0-0.158-0.074-0.299-0.188-0.39l-0.001-0.001-3.457-3.457c-0.090-0.090-0.216-0.146-0.354-0.146-0.276 0-0.5 0.224-0.5 0.5 0 0.138 0.056 0.263 0.146 0.354l2.642 2.642h-8.295c-0.548-0.001-0.992-0.445-0.993-0.993v-6.007c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v0 6.007c0.001 1.1 0.893 1.992 1.993 1.993h8.305l-2.651 2.651c-0.090 0.090-0.146 0.216-0.146 0.354 0 0.276 0.224 0.5 0.5 0.5 0.138 0 0.263-0.056 0.354-0.146l3.5-3.5c0.090-0.090 0.146-0.215 0.146-0.353 0-0.001 0-0.002-0-0.003v0z"></path>
);
